import React from 'react'

import { RichTextProps } from './rich-text.d';

import RichTextWrapper from '/react4xp/components/RichTextWrapper';

function RichTextPart(props: RichTextProps) {
    return (
        <RichTextWrapper {...props} />
    )
}

export default (props) => <RichTextPart {...props} /> 
